export const datesLabels = {
  firstRating: 'First rating',
  initialScore: 'Initial score',
  lastRatingAction: 'Last rating action',
  latestRating: 'Latest rating',
  latestChange: 'Latest change',
  firstReview: 'First review',
  lastReviewAction: 'Last review action',
};

export const datesLabelsCreditReview = {
  firstRating: 'First rating',
  initialScore: 'Initial assessment',
  lastRatingAction: 'Last rating action',
  latestRating: 'Latest rating',
  latestChange: 'Latest change since request',
  firstReview: 'First review',
  lastReviewAction: 'Last review action',
};
